import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { CustomHttpInterceptor } from './http.interceptors';

export const httpInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true }];
